import process_1_svg from 'assets/process_1.svg';
import process_2_svg from 'assets/process_2.svg';
import process_3_svg from 'assets/process_3.svg';
import process_4_svg from 'assets/process_4.svg';
import { SelectData } from 'shared/components/atoms/SelectBox';

export const dayOfWeekStr = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
export const streaming_reception_billing_options = [
  { name: '14日 (無料)', value: '14' },
  { name: '31日 (無料)', value: '31' },
  { name: '93日 (無料)', value: '93' },
  { name: '186日 (30,000円/月)', value: '186' },
  { name: '366日 (50,000円/月)', value: '366' },
];
export const widget_types: SelectData[] = [
  {
    name: 'グラフ',
    value: 'GRAPH',
  },
  {
    name: 'ライブテキスト',
    value: 'LIVETEXT',
  },
  {
    name: 'エリアカウント',
    value: 'AREACOUNT',
  },
  {
    name: '複数データの合算表示',
    value: 'SUMUPGRAPH',
  },
  {
    name: 'ビデオプレーヤー',
    value: 'VIDEOPLAYER',
  },
  {
    name: 'マップ',
    value: 'MAP',
  },
  {
    name: 'バス停毎の乗車人数、降車人数',
    value: 'BUSOD1',
  },
  {
    name: '日別の乗車人数',
    value: 'BUSOD2',
  },
  {
    name: '乗車バス停と降車バス停のヒートマップ',
    value: 'BUSOD3',
  },
  {
    name: 'ヒートマップ',
    value: 'HEATMAP',
  },
];

export const area_name = ['AREA0', 'AREA1', 'AREA2', 'AREA3', 'LINE0', 'LINE1', 'LINE2', 'LINE3'];

export const count_target: SelectData[] = [
  {
    name: 'なし → 無し',
    value: 'N-N',
  },
  {
    name: 'なし → 0',
    value: 'N-0',
  },
  {
    name: 'なし → 1',
    value: 'N-1',
  },
  {
    name: 'なし → 2',
    value: 'N-2',
  },
  {
    name: 'なし → 3',
    value: 'N-3',
  },
  {
    name: 'なし → 4',
    value: 'N-4',
  },
  {
    name: '0 → なし',
    value: '0-N',
  },
  {
    name: '0 → 0',
    value: '0-0',
  },
  {
    name: '0 → 1',
    value: '0-1',
  },
  {
    name: '0 → 2',
    value: '0-2',
  },
  {
    name: '0 → 3',
    value: '0-3',
  },
  {
    name: '0 → 4',
    value: '0-4',
  },
  {
    name: '1 → なし',
    value: '1-N',
  },
  {
    name: '1 → 0',
    value: '1-0',
  },
  {
    name: '1 → 1',
    value: '1-1',
  },
  {
    name: '1 → 2',
    value: '1-2',
  },
  {
    name: '1 → 3',
    value: '1-3',
  },
  {
    name: '1 → 4',
    value: '1-4',
  },
  {
    name: '2 → なし',
    value: '2-N',
  },
  {
    name: '2 → 0',
    value: '2-0',
  },
  {
    name: '2 → 1',
    value: '2-1',
  },
  {
    name: '2 → 2',
    value: '2-2',
  },
  {
    name: '2 → 3',
    value: '2-3',
  },
  {
    name: '2 → 4',
    value: '2-4',
  },
  {
    name: '3 → なし',
    value: '3-N',
  },
  {
    name: '3 → 0',
    value: '3-0',
  },
  {
    name: '3 → 1',
    value: '3-1',
  },
  {
    name: '3 → 2',
    value: '3-2',
  },
  {
    name: '3 → 3',
    value: '3-3',
  },
  {
    name: '3 → 4',
    value: '3-4',
  },
  {
    name: '4 → なし',
    value: '4-N',
  },
  {
    name: '4 → 0',
    value: '4-0',
  },
  {
    name: '4 → 1',
    value: '4-1',
  },
  {
    name: '4 → 2',
    value: '4-2',
  },
  {
    name: '4 → 3',
    value: '4-3',
  },
  {
    name: '4 → 4',
    value: '4-4',
  },
];

export const normal_process_texts = ['人数カウント', '車数カウント', '密度検知', '不法投棄'];

export const process_images = [process_1_svg, process_2_svg, process_3_svg, process_4_svg];

export const sample_result_csv_header = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];

export const sample_result_csv = [
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
  {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0,
    G: 0,
    H: 0,
    I: 0,
    J: 0,
    K: 0,
    L: 0,
  },
];
